import _ from "lodash";
import typeSelect from "./components/select/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getProductPriceTitle, resolveHoverProductImage, resolveProductImage, routeToProduct } from "@/helpers";
import ValentineIcon from "@/components/@icons/ValentineIcon.vue";

export default {
  name: "product",
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    hover: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ValentineIcon,
    typeSelect,
  },
  data() {
    return {
      isProductPriceInBasket: false,
      selectedProductPrice: null,
      favoriteSelect: false,
      basketKey: 1,
      leftoverType: null,
      width: 200,
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      favourites: "favorites/whichList",
      basket: "basket/basket",
      user: "profile/user",
      showNotifyLoader: "products/showNotifyLoader",
    }),
    showValentineIcon() {
      const now = new Date();
      const startDate = new Date(2026, 1, 9, 9, 0, 0);
      const endDate = new Date(2026, 1, 14, 23, 59, 59);
      return now >= startDate && now <= endDate;
    },
    isOutlet() {
      return this.$route.query && this.$route.query.categories && this.$route.query.categories.includes("outlet");
    },
  },
  mounted() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
  watch: {
    selectedProductPrice: function () {
      this.$router.query = this.selectedProductPrice.value;
      this.selectProductPrice(this.selectedProductPrice);
    },
    basket: function () {
      this.basketKey += 1;
      this.checkProductInBasket();
    },
  },
  created() {
    if (this.product.productPrices?.data) {
      if (this.findOutletProductPrice() && this.isOutlet) {
        this.selectProductPrice(this.findOutletProductPrice());
        return;
      }
      let sorted = this.product.productPrices?.data.sort((a, b) => b.value - a.value);
      sorted = sorted.sort((a, b) => {
        // if (this.isAuthenticated && (!this.isProfessional || !this.isDistributor)) {
          if (a.isRefill && !b.isRefill) return 1;
          if (!a.isRefill && b.isRefill) return -1;
          if (a.outletReasons?.data?.length && !b.outletReasons?.data?.length) return 1;
          if (!a.outletReasons?.data?.length && b.outletReasons?.data?.length) return -1;
        // }

        return a.value - b.value;
      });
      this.selectProductPrice(sorted[0]);
    }
  },
  methods: {
    getProductPriceTitle,
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeFastBuyPopup: `popups/CHANGE_FAST_BUY_POPUP`,
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
      showSmsRegisterPopup: "auth/SHOW_PHONE_REGISTER_POPUP",
    }),
    ...mapActions({
      addToFavorite: "favorites/ADD_PRODUCT_TO_FAVOURITES",
      removeFromFavorite: "favorites/REMOVE_PRODUCT_IN_FAVORITE",
      getFavorites: "favorites/GET_FAVORITES_LIST",
      showNotifyPopup: "products/SHOW_POPUP_PRODUCT_WHEN_AVAILABLE",
    }),
    routeToProduct: routeToProduct,
    resolveProductImage: resolveProductImage,
    resolveHoverProductImage: resolveHoverProductImage,
    updateWidth() {
      if (this.$refs.productCard) {
        this.width = this.$refs.productCard.offsetWidth;
      }
    },
    findOutletProductPrice() {
      if (this.product.productPrices?.data) {
        return this.product.productPrices.data.find(product => {
          return product.outletReasons?.data?.length;
        });
      }
      return null;
    },
    addDataLayer() {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          item_list_id: "Cosmetics",
          item_list_name: "Cosmetics",
          items: [
            {
              item_id: this.product.productPrices.data[0].article,
              item_name: this.product.title,
              affiliation: "SkinOn-Cosmetics",
              coupon: "",
              discount: 0.0,
              index: 0,
              item_brand: this.product?.brand?.title || "SkinOn",
              item_category: this.product?.brandSeries?.title || "",
              item_category2: (() => {
                if (!this.isAuthenticated) return "unauthorized";
                if (this.isProfessional) return "professional";
                if (this.isDistributor) return "distributor";
                return "regular";
              })(),
              item_list_id: "Cosmetics",
              item_list_name: "Cosmetics",
              location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
              price: this.product.productPrices.data[0].price,
              quantity: 1,
            },
          ],
        },
      });
    },
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      this.selectedProductPrice = productPrice;
      this.leftoverType = productPrice.leftoverType.data;
      this.checkProductInBasket();
    },
    viewPrices() {
      this.changeLoginPopup(true);
    },
    openFastBuy() {
      this.changeFastBuyPopup({
        show: true,
        product: {
          select_count: 1,
          select_type: this.selectedProductPrice,
          ...this.product,
        },
      });
    },
    checkProductInBasket() {
      this.basketKey += 2;
      this.isProductPriceInBasket = _.some(this.basket, { select_type: { id: this.selectedProductPrice.id } });
    },
    addBasket() {
      if (this.product.hasDuplicate) {
        this.$toasted.info("Цей товар переміщено до новї серії та не можливо купи");
        return;
      }

      this.addToBasket({
        select_count: 1,
        product_price: this.selectedProductPrice,
        product: this.product,
        unauthorizedProductPriceId: this.product.unauthorizedProductPriceId,
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "UAH",
          value: this.selectedProductPrice.price,
          items: [
            {
              item_id: this.selectedProductPrice.article,
              item_name: this.product.title,
              affiliation: "SkinOn-Cosmetics",
              coupon: "",
              discount: 0.0,
              index: 0,
              item_brand: this.product?.brand?.title || "SkinOn",
              item_category: this.product?.brandSeries?.title || "",
              item_category2: (() => {
                if (!this.isAuthenticated) return "unauthorized";
                if (this.isProfessional) return "professional";
                if (this.isDistributor) return "distributor";
                return "regular";
              })(),
              item_list_id: "Cosmetics",
              item_list_name: "Cosmetics",
              location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
              price: this.selectedProductPrice.price,
              quantity: 1,
            },
          ],
        },
      });

      // eslint-disable-next-line no-undef
      fbq("track", "AddToCart", {
        content_type: "product",
        currency: "UAH",
        value: this.selectedProductPrice.price,
        content_name: this.product.title,
        content_ids: this.product.unauthorizedProductPriceId,
        content_category: this.product.brandSeries?.title || this.product.brand?.title || this.product.title,
      });
      this.changeBasketPopup(true);
      this.checkProductInBasket();
    },
    showNotify() {
      const payload = {
        product_id: this.product.id,
        product_price_id: this.selectedProductPrice.id,
      };

      this.showNotifyPopup(payload);
    },
    changeFavorite() {
      if (this.isAuthenticated) {
        const index = this.favourites.find(e => e.productId === this.product.id);
        if (index) {
          this.removeFromFavorite(index.id).then(() => {
            this.getFavorites();
            this.favoriteSelect = false;
            this.$toasted.success(this.$t("successRemoveFromFavorite"));
          });
        } else {
          this.addToFavorite({ product_id: this.product.id }).then(() => {
            this.favoriteSelect = true;
            this.$toasted.success(this.$t("successAddToFavorites"));
            this.getFavorites();
          });
        }
      } else {
        this.changeLoginPopup(true);
      }
    },
  },
};
